<div class="work-task">
  <form (ngSubmit)="submitWorkTask()" [formGroup]="form" novalidate>
    <div class="form-group">
      <label>Subject</label>
      <input type="text" class="form-control" placeholder="subject" formControlName="subject">
    </div>
    <div class="form-group">
      <label>Assigned To</label>
      <select class="form-control select-box" formControlName="assignedTo">
        <option value=""></option>
        @for (m of admins; track m) {
          <option [value]="m.userAccountId">{{m.firstName}} {{m.lastName}}</option>
        }
      </select>
    </div>
    <div class="form-group">
      <label>Due On</label>
      <input type="date" class="form-control" placeholder="Due On" formControlName="dueOn">
    </div>
    <div class="form-group">
      <label>Completed On</label>
      <input type="date" class="form-control" placeholder="Completed On" formControlName="completedOn">
    </div>
    <div class="form-group">
      <label>Comments</label>
      <textarea class="form-control" placeholder="Comments" formControlName="comments"></textarea>
    </div>
    <div class="btn-continue">
      <button type="submit" class="btn btn-primary" [disabled]="form.invalid || loading">
        @if (loading) {
          <i class="fa fa-circle-notch fa-spin"></i>
        }
        Save
      </button>
      @if (model?.id > 0) {
        <button type="button" class="btn btn-danger" (click)="delete()">
          Delete
        </button>
      }
      <button type="button" class="btn btn-default" (click)="cancel.emit()">
        Cancel
      </button>
    </div>
  </form>
</div>